import { PDFDocument, degrees } from 'pdf-lib';
import { parsePageSelection } from '../split/splitPdfEngine';

async function loadPdf(file) {
    const bytes = await file.arrayBuffer();
    try {
        return await PDFDocument.load(bytes, { ignoreEncryption: true });
    } catch (err) {
        if (String(err?.message || '').toLowerCase().includes('encrypt')) {
            throw new Error('password');
        }
        throw err;
    }
}

function normalizeAngle(angle) {
    return ((angle % 360) + 360) % 360;
}

/**
 * Rotate PDF pages by a relative angle.
 * @param {File} file
 * @param {{ delta: number, scope: 'all'|'selected', pageInput?: string, pageCount: number, pages?: Array<{ pageIndex: number, rotation?: number, sourcePageNumber?: number }> }} options
 */
export async function rotatePdf(file, options) {
    const source = await loadPdf(file);
    const sourcePages = source.getPages();
    const total = sourcePages.length;
    const entries = Array.isArray(options.pages) && options.pages.length
        ? options.pages
        : sourcePages.map((_, pageIndex) => ({ pageIndex, rotation: 0, sourcePageNumber: pageIndex + 1 }));

    const selectedIndices = options.scope === 'all'
        ? new Set(entries.map((entry) => entry.pageIndex))
        : parsePageSelection(options.pageInput || '', options.pageCount || total);
    const selectedSet = selectedIndices instanceof Set ? selectedIndices : new Set(selectedIndices);
    const out = await PDFDocument.create();
    const copiedPages = await out.copyPages(source, entries.map((entry) => entry.pageIndex));

    copiedPages.forEach((page, index) => {
        const entry = entries[index];
        const current = page.getRotation().angle;
        const perPageRotation = entry?.rotation || 0;
        const batchRotation = selectedSet.has(entry.pageIndex) ? options.delta : 0;
        page.setRotation(degrees(normalizeAngle(current + perPageRotation + batchRotation)));
        out.addPage(page);
    });

    const output = await out.save();
    return new Blob([output], { type: 'application/pdf' });
}
